export default __webpack_public_path__ + "static/media/object-book_darkGray3.5565953b.svg";